<template>
  <!-- 企业控制台布局 -->
  <div class="console-wrap">
    <div :class="{ 'console-header': true, nbd: isConsoleHome }">
      <div class="con-box">
        <div class="account" style="display:flex">
          <div class="flex-b nw">
            <!-- <p style="margin-right: 20px; font-weight: bold; font-size: 16px">控制台</p> -->
            <img
              class="photo"
              :src="
                currentAuthUser.imgPath  && !isInDingTalk
                  ? fileOperShow(currentAuthUser.imgPath)
                  : ''
              "
              onerror="this.src='/images/web/login_user_icon.png'"
            />
            <div class="moreInfo">
              <img
                style="width: 20px; height: 20px; margin-right: 5px;"
                v-if="currentAuthUser.userStemFrom === -16 && !isInDingTalk"
                src="/images/icon/dingIcon.png"
                alt
              />
              <span class="name">{{ corpName }}</span>
            </div>
            <i v-if="!isInDingTalk" class="el-icon-caret-bottom" style="font-size: 24px;"></i>
          </div>
          <div class="comp-expand" v-if="!isInDingTalk">
            <change-account
              @showExpandIcon="showExpandIcon"
              :users="consoleUsers"
              :ywtAccountChoose="true"
            />
          </div>
        </div>
        <div style="display: flex; justify-content: flex-end">
          <ul>
            <li
              v-for="(item, index) in endConsoleMenus"
              :key="index"
              :id="'menu' + index"
              :class="{ active: getMenu(item) }"
              @click="toMenusItem(item)"
            >
              <span>{{ item.name }}</span>
            </li>
          </ul>
          <div class="ls-sh">
            <el-button class="backBZ" @click="turnBack">返回首页</el-button>
          </div>
        </div>
      </div>
    </div>

    <!--内容 start-->
    <template v-if="isConsoleHome">
      <!--首页-->
      <nuxt />
    </template>
    <el-container
      v-else
      style="overflow-x: auto; margin-bottom: 20px"
      :style="{ 'min-height': '100%' }"
    >
      <div class="main">
        <el-main v-if="isRouterAlive">
          <div class="bread">
            <!--            <bread-crumb :menuEnums="menusEnum"></bread-crumb>-->
          </div>
          <nuxt />
        </el-main>
      </div>
    </el-container>
    <!--内容 end-->
    <suspend />

    <my-footer />
  </div>
</template>

<script>
import { fileOperShow, logout } from "../assets/js/http-serve/http-methods";
import { setCurrentUser } from "../assets/js/http-serve/corp/common";
import { gantConf } from "../assets/js/utils/jurisdiction";
import BreadCrumb from "@/components/corp-comps/Bread-Crumb";
import ChangeAccount from "@/components/change-account";
import UserHeader from "@/components/header/userHeader.vue";
import MyFooter from "@/components/myfooter/index.vue";
import { isInDingTalk } from "../assets/js/utils/ding-env";
import { consoleMenus as consoleMenusNew } from "./js/entConsoleDate";
import { ding_erformance } from "./js/entConsoleDate.js"

export default {
  name: "entconsolelayout",
  components: {
    BreadCrumb,
    ChangeAccount,
    UserHeader,
    MyFooter
  },
  beforeMount () {
    // *********************是否有查看控制台的权限判断start*********************
    let bool = true,
      accountInfoVO = this.$store.getters.allAuthUser.accountInfoVO;
    if (this.currentAuthUser.corpUserId === undefined) {
      // 外面用户进来，切换到超级管理员
      if (this.$store.getters.allAuthUser.manCorpUser) {
        bool = false;
        setCurrentUser(this.$store.getters.allAuthUser.manCorpUser);
      }
    }
    // 集团账户有权限
    if (
      this.currentAuthUser &&
      this.currentAuthUser.perms &&
      this.currentAuthUser.perms.length > 0
    ) {
      bool = false;
    }
    if (accountInfoVO && accountInfoVO.identityAuth != 1) {
      this.$message.info("请先完成实名认证");
      this.$router.push("/viewIndex");
    }
  },
  created () {
    this.changePageByCurrentUser(this.currentAuthUser);
    this.menusByType()
  },
  mounted(){ding_erformance()},
  computed: {
    endConsoleMenus () {
      if (this.BasicVersion()) {
        const { auditLog, tempManage, approval, memberManage } = gantConf;
        return this.consoleMenusArr.filter((item) => {
          if (item.pid === 4) {
            item.name = '印章管理'
          }
          return ![memberManage, tempManage, approval, auditLog].includes(item.pid)
        })
      } else {
        this.consoleMenusArr.forEach((item) => {
          if (item.pid === 4) {
            item.name = '印章及授权'
          }
        })
        return this.consoleMenusArr;
      }
    },
    loginUser () {
      return this.$store.getters.allAuthUser
        ? this.$store.getters.allAuthUser.accountInfoVO
        : {};
    },
    // 是否控制台首页
    isConsoleHome () {
      return this.$route.path.indexOf("/console/consoleIndex") > -1;
    },
    currentAuthUser () {
      return this.$store.getters.currentAuthUser || {};
    },
    corpName () {
      if (
        this.currentAuthUser.userType == 1 ||
        this.currentAuthUser.userType == 0
      ) {
        //外部用户，一般情况下应该是超级管理员
        if (
          this.$store.getters.allAuthUser &&
          this.$store.getters.allAuthUser.corpCreateFlag == 1 &&
          this.$store.getters.allAuthUser.manCorpUser
        ) {
          return this.$store.getters.allAuthUser.manCorpUser.corpName || "";
        }
      }
      return this.currentAuthUser.corpName || "";
    },
    getTitle () {
      let name = this.corpName;
      let accountName = this.$store.getters.allAuthUser
        ? this.$store.getters.allAuthUser.accountInfoVO.name
        : "";
      return name !== accountName ? name + "-" + accountName : name;
    },
    userName () {
      if (this.currentAuthUser.superFlag === 1) {
        return "超级管理员";
      } else {
        return this.currentAuthUser.userName || "";
      }
    },
    // 获取拥有控制台权限的用户
    consoleUsers () {
      try {
        let users = this.$store.getters.allAuthUser.bindCorpUsers;
        let consoleUsers = [];
        // console.log(this.$store.getters.allAuthUser);
        if (this.$store.getters.allAuthUser.corpCreateFlag === 1) {
          // 超级管理员
          consoleUsers.push(this.$store.getters.allAuthUser.manCorpUser);
        }
        users.forEach(user => {
          if (user.perms && user.perms.length > 0) {
            consoleUsers.push(user);
          }
        });
        return consoleUsers;
      } catch (e) {
        return [];
      }
    },
    /**
     * 企业高级版的超级管理员
     * 1、当且仅当企业高级版的超级管理员登录后，直接到企业控制台页面（在控制台页面中增加返回“标准版”链接，此链接只有超级管理员可见）；
     * 2、企业控制台页面的logout功能修改：当且仅当是超级管理员本人时，logout后直接到login页面
     * */
    isAdminAndHasEntH () {
      let currentUser = this.$store.getters.currentAuthUser;
      let allUser = this.$store.getters.allAuthUser;
      // corpCreateFlag 为1，开通企业高级服务 manCorpUser为1，超级管理员
      try {
        // currentUser无corpUserId
        // 初始进入，accountInfoVO可能赋值给currentUser
        if (
          allUser &&
          allUser.corpCreateFlag == 1 &&
          currentUser &&
          currentUser.merchantFlag == 1 &&
          currentUser.userType != undefined
        ) {
          return true;
        }
        // currentUser有corpUserId
        if (
          allUser &&
          allUser.corpCreateFlag == 1 &&
          allUser.accountInfoVO.merchantFlag == 1 &&
          allUser.manCorpUser.corpUserId == currentUser.corpUserId
        ) {
          // manCorpUser.corpUserId为当前登录账户的id
          return true;
        }
        return false;
      } catch (e) {
        return false;
      }
    }
  },
  watch: {
    $route: {
      handler (val) {
        // this.setDefaultActive(val.path);
      },
      deep: true
    },
    "$store.getters.currentAuthUser": {
      handler (newVal, oldVal) {
        this.changePageByCurrentUser({
          oldUserInfo: oldVal,
          newUserInfo: newVal
        });
      },
      deep: true
    }
  },
  methods: {
    /** 是否基础版 */
    BasicVersion () {
      // if(isInDingTalk){
      //   return true;
      // }else{
        return this.$store.getters.allAuthUser.accountInfoVO.userType === 1 && this.$store.getters.allAuthUser.accountInfoVO.layoutVersion === 1
      // }
    },
    /** 点击菜单跳转 */
    toMenusItem (item, check) {
      // 获取权限
      const { perms: storePerms } = this.$store.getters.consoleToken || {};
      const
        /** 【perms】当前账号主体所有权限 */
        perms = [...(storePerms ? storePerms : [])], { enterpriseSealManage, sealAuth,
          sealManage, tempManage, tempManageSub,
          tempAuth, organStru,
          roleManage,
          memberManage,
          documentApproval,
          sealApproval,
          approval,
          auditLog, consumption } = gantConf;
      /** 判断是否有【印章及授权】权限 pid : sealManage */
      const signAuth = perms.includes(enterpriseSealManage) ||
        perms.includes(sealAuth) ||
        perms.includes(sealManage)
      /** 判断是否有【模板管理】权限 pid : tempManage */
      const TempMangeAuth = perms.includes(tempManage) ||
        perms.includes(tempManageSub) ||
        perms.includes(tempAuth);
      /** 【成员管理】【meterAuth】菜单, 拥有一项子权限就显示。老数据：如果没有两个子权限但拥有父级也显示  pid :memberManage */
      const meterAuth = perms.includes(organStru) ||
        perms.includes(roleManage) ||
        perms.includes(memberManage);
      /**【成员合同审批】【approvalAuth】菜单, 拥有一项子权限就显示。老数据：如果没有两个子权限但拥有父级也显示 pid : approval */
      const approvalAuth =
        perms.includes(documentApproval) ||
        perms.includes(sealApproval) ||
        perms.includes(approval);
      const
        /**【操作日志审计】 pid:auditLog */
        auditLogAuth = perms.includes(auditLog),
        /** 有无消费统计权限 */
        consumptionAuth = perms.includes(consumption),
        { pid } = item;
      // console.log('item',item);
      // console.log('perms',perms);
      const
        /** 是否有印章菜单及页面权限 */
        _signAuth = pid === sealManage && signAuth,
        /** 是否有模板管理菜单及页面权限 */
        _TempMangeAuth = pid === tempManage && TempMangeAuth,
        /** 是否有成员管理菜单及页面权限 */
        _meterAuth = pid === memberManage && meterAuth,
        /** 是否有审批管理菜单及页面权限 */
        _approvalAuth = pid === approval && approvalAuth,
        /** 是否有审计日志菜单及页面权限 */
        _auditLogAuth = pid === auditLog && auditLogAuth,
        /** 是否有消费统计菜单及页面权限 */
        _consumptionAuth = pid === consumption && consumptionAuth;
      const haveMenu = _signAuth || _TempMangeAuth || _meterAuth || _approvalAuth || _auditLogAuth || _consumptionAuth
      if (haveMenu || (!check && pid === -1)) {
        // console.log('item.path:::',item.path);
        if (!check) this.$router.push(item.path)
        this.activeMenusItem = item
        return 1
      } else {
        if (!check) this.$message.error(`暂无此菜单权限，如需使用请联系管理员开通`)
        return false
      }
    },
    /** 移除某项菜单 */
    delMenusItem (pid) {
      for (let i = 0; i < this.consoleMenusArr.length; i++) {
        const elem = this.consoleMenusArr[i];
        if (elem.pid === pid) this.consoleMenusArr.splice(i, 1);
      }
    },
    /** 根据账号类型添加菜单项 */
    menusByType () {
      const { perms: storePerms } = this.$store.getters.consoleToken || {};
      const perms = [...(storePerms ? storePerms : [])], current = this.$store.getters.currentAuthUser, binds = this.$store.getters.allAuthUser.bindCorpUsers;
      const bindCorpIds = binds.map(bind => bind.corpUserId)
      let consumptionAuth = perms.includes(gantConf.consumption);
      const isCorp = bindCorpIds.includes(current.corpUserId);
      if (isCorp) {
        const have = this.consoleMenusArr.some(item => item.pid === gantConf.consumption)
        if (!have) {
          this.delMenusItem(-1)
          this.consoleMenusArr.push({
            pid: gantConf.consumption,
            name: '企业消费统计',
            path: "/console/account",
            tip: ""
          });
        }
      }
      if (!isCorp) {
        const have = this.consoleMenusArr.some(item => item.pid === -1)
        if (!have) {
          this.delMenusItem(gantConf.consumption)
          this.consoleMenusArr.push({
            pid: -1, //不需要权限
            name: "企业账户中心",
            path: "/console/account?type=2",
            tip: ""
          });
        }

      }
    },
    accountFn () {
      setCurrentUser(this.$store.getters.currentAuthUser).finally(() => {
        // 切换登录用户
        if (this.$route.path !== "/signSettings/costStatistics") {
          this.$router.push({ path: "/signSettings/costStatistics" });
        }
      });
    },
    turnBack () {
      this.toIndex()
    },
    toIndex () {
      this.$router.push({ path: "/viewIndex" })
      setTimeout(() => {
        setCurrentUser(this.$store.getters.allAuthUser.accountInfoVO);
      }, 500);

    },
    // 登录账户是否开通企业高级服务
    isSenior () {
      let currentUser = this.$store.getters.currentAuthUser;
      let allUser = this.$store.getters.allAuthUser;

      let name = currentUser.corpName || currentUser.name;
      if (
        allUser.manCorpUser &&
        allUser &&
        allUser.accountInfoVO.name === name
      ) {
        // 登录的企业并且开通了企业控制台权限的
        return true;
      }
      return false;
    },
    /***
     * 切换用户
     * @param oldUserInfo 切换前的用户信息 从store获取
     * @param newUserInfo 切换后的用户信息 从store获取
     */
    async changePageByCurrentUser ({ oldUserInfo, newUserInfo }) {
      const firstPath = this.consoleMenusArr[0].path,routePath = this.$route.path,personToCorp = sessionStorage.getItem('personToCorp');
      const path = personToCorp || this.BasicVersion() ? routePath : firstPath
      if (this.$route && routePath === "/console") {
        this.activeMenusItem = path
        this.$router.push({
          path,
          query:this.$route.query
        }, () => { });
      } else {
        if (!Object.keys(this.activeMenusItem).length) {
          const initPath = this.endConsoleMenus.filter(item => item.path === this.$route.path)
          this.activeMenusItem = initPath.length ? initPath[0] : ''
        }
        const menusAuth = await this.toMenusItem(this.activeMenusItem, 1)
        if (Number(this.$store.getters.allAuthUser.accountInfoVO.userType) === 1 && this.$route.query.account) {
          return false;
        } else if (!menusAuth) {
          this.activeMenusItem = path
          this.$router.push({ path,query:this.$route.query }, () => { });
          this.reload()
        } else {
          this.reload();
        }
      }
      // 菜单展示会因为切换的账户类型发生改变
      this.menusByType();
      sessionStorage.removeItem('personToCorp');
    },
    /**
     * 获取页面对应的权限
     * @returns {*}
     */
    getMenuByUrl () {
      let path = this.$route.path;

      // 递归找到当前url对应的权限菜单项
      let dgFn = arr => {
        for (let x = 0; x < arr.length; x++) {
          if (path.indexOf(arr[x].path) > -1) {
            return arr[x];
          }
          if (arr[x].children && arr[x].children.length > 0) {
            let childItem = dgFn(arr[x].children);
            if (childItem) return childItem;
          }
        }
        return "";
      };

      return dgFn(this.consoleMenusArr);
    },
    /***
     * 刷新页面方法
     */
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    showExpandIcon () {
      this.showExpand = true;
    },
    /**
     *  根据页面url 找到对应应该激活的一级菜单
     * */
    getMenu (item) {
      let path = this.$route.path;
      // 递归查找当前菜单及其子集是否包含当前页面路径
      let fd = function (cuIt) {
        const samePath = cuIt.path.indexOf(path) > -1;
        if (samePath) {
          return true;
        } else {
          if (cuIt.children && cuIt.children.length) {
            for (let i = 0; i < cuIt.children.length; i++) {
              if (fd(cuIt.children[i])) {
                return true;
              }
            }
            return false;
          } else {
            return false;
          }
        }
      };
      return fd(item);
    }
  },
  data () {
    return {
      showMore: true, // 是否展示控制台info更多按钮
      activeMenusItem: {}, // 当前选中的菜单
      consoleMenusArr: consoleMenusNew, // 控制台菜单 // 控制台菜单
      isInDingTalk,
      logout: logout,
      height: "100%",
      defaultActive: "",
      menuTpl: [
        {
          pid: 4,
          name: "印章及授权",
          path: "/console/seal",
          tip: "设置企业签章，将签章授权给成员，即可代表企业签署文件。"
        },
        {
          pid: 6,
          name: isInDingTalk ? "模板管理" : "模板及授权",
          more: true,
          path: "/console/template",
          tip: "设置模板，将模板授权给成员，方便统一公司发起的文件内容规范。",
          isLink: true,
          children: [
            {
              name: "添加模板",
              // path: "/console/authEdit",
              path: "/authEdit/variableEditor", //替换新编辑器地址-1903
              query: {}, // 子页面也需要配置query和match，用于匹配
              match: {
                keys: [],
                name: "编辑模板" // 匹配成功后显示的title
              }
            },
            {
              name: "新增高级模板",
              path: "/advancedVersion/addTpl",
              query: {} // 子页面也需要配置query和match，用于匹配
            }
          ]
        },
        {
          pid: 3,
          name: isInDingTalk ? "组织及权限" : "组织及权限",
          path: "/console/member",
          tip:
            "通过手机号码邀请成员，成员收到短信验证身份后即可加入。成员离职可移除成员，邀请新的成员。",
          children: [
            {
              pid: 7,
              name: "组织管理",
              path: "/console/organization",
              tip:
                "添加组织，实现企业分公司、部门等管理需求。设置部门主管用于文件发起的审批流程。"
            },
            {
              pid: [8, 9], // 包含角色权限，角色分配
              name: "角色管理",
              path: "/console/role",
              tip:
                "给企业管理者分配管理角色，管理者可自行邀请成员，分配签章权限。"
            }
          ]
        },

        {
          pid: 12,
          name: "成员合同审批",
          path: "/console/flow",
          tip: "设置审批流程，减少对外发出文件的风险。",
          children: [
            {
              name: "添加发起审批",
              path: "/console/approval",
              query: {
                flowType: 0
              },
              match: {
                keys: ["flowType"],
                name: "编辑发起审批" // 匹配成功后显示的title
              }
            },
            {
              name: "添加盖章审批",
              path: "/console/approval",
              query: {
                flowType: 1
              },
              match: {
                keys: ["flowType"],
                name: "编辑盖章审批" // 匹配成功后显示的title
              }
            }
          ]
        },
        // {
        //   pid: 10,
        //   name: "操作日志审计",
        //   path: "/console/log",
        //   tip: "操作日志审计，方便追诉企业签章使用、后台成员设置等操作行为。"
        // }
      ],
      fileOperShow: fileOperShow,
      isRouterAlive: true,
      showExpand: false
    };
  },
};
</script>

<style lang="less" scoped>
@import url("../assets/style/cssVariable.less");
@media (max-width: 1366px) {
  .console-header {
    .moreInfo {
      // display: none !important;
      .name {
        white-space: nowrap; /* 禁止文本换行，强制单行显示 */
        overflow: hidden; /* 隐藏超出容器的内容 */
        text-overflow: ellipsis; /* 超出部分使用省略号表示 */
        cursor: pointer; /* 鼠标悬停时显示指针，表示可点击 */
      }
    }
  }
  .con-box {
    width: 100% !important;
  }
}
.ctop {
  width: 100%;
  height: 40px;
  background: #ec1c1c;

  .box {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .toplogo {
    height: 35px;
    width: auto;
    display: inline-block;
    vertical-align: middle;
  }

  .top-header {
    height: 40px;

    &:hover /deep/ ul {
      top: 40px;
    }
  }
}

.icon-qh {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("/images/icon-qh.png") no-repeat;
  background-size: 100% 100%;
  margin-left: 10px;
}

.backBZ {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: @ebq-red;
  padding: 7px 10px;
  border-radius: 4px;

  &:hover {
    background: @ebq-bg-turn;
  }
}

.console-logo {
  display: block;
  line-height: 60px;

  img {
    height: 35px;
    width: auto;
  }
}

.menu_btn {
  float: left;
  background: url("/static/images/console/menu_in.png") no-repeat;
  background-size: cover;
  width: 32px;
  height: 32px;
  position: relative;
  top: 15px;

  &.out {
    background: url("/static/images/console/menu_out.png") no-repeat;
  }
}

.main {
  width: 1366px;
  // width: 1200px;
  margin: 0 auto;

  .header {
    height: 60px;
    line-height: 60px;
    background-color: #ffffff;
    border-bottom: solid 1px rgb(233, 233, 233);
    color: #656565;

    .operation-right {
      max-width: 100%;
      margin-left: 80px;
      display: inline-block;
      float: right;
      white-space: nowrap;

      .comp-info {
        width: 260px;
        position: relative;
        float: left;
        display: inline-block;
        margin-right: 30px;

        .checked-info {
          position: relative;
          z-index: 6;
          height: 59px;
          padding: 0 10px;
          background-color: #ffffff;

          .photo {
            margin-right: 15px;
            border-radius: 50%;
            border: solid 1px #ddd;
          }

          .el-icon-arrow-right {
            font-size: 16px;
            transition: all 0.2s linear;
            vertical-align: middle;
            margin-bottom: 2px;
            margin-left: 15px;
          }
        }

        .comp-expand {
          position: absolute;
          width: calc(100% - 4px);
          z-index: 5;
          top: 56px;
          left: 2px;
          background-color: #ffffff;
          box-shadow: 0 2px 3px #ddd;
          transform: translateY(-100%);
          transition: all 0.3s;

          /deep/ .change-account {
            li {
              border-bottom: solid 1px #ddd;
              .current-user {
                right: 15px;
              }
            }

            .search-profile {
              position: absolute;
              background-color: #ffffff;
              padding: 0 20px;
              border-bottom: solid 1px #ddd;
            }

            .wrap {
              overflow-y: auto;
              max-height: 420px;
            }
          }
        }

        &:hover {
          .el-icon-arrow-right {
            transform: rotate(90deg);
          }

          .comp-expand {
            transform: translateY(0);
          }
        }
      }

      & > span {
        display: inline-block;
        margin-right: 38px;
        padding: 0 20px;

        &:last-child {
          margin-right: 0;
          padding-right: 0;
        }
      }

      .clickable {
        cursor: pointer;

        &:hover {
          background-color: #efefef;
        }
      }

      .profile {
        img {
          vertical-align: middle;
          margin-bottom: 2px;
        }
      }
    }
  }

  .menu-name {
    font-size: 18px;
    font-weight: bold;

    /deep/ & > .role {
      background-color: #ffffff;
    }
  }

  /deep/ .el-main {
    // min-height: calc(100% - 60px); /*减掉底部60px*/
    min-height: calc(100vh - 120px);
    padding: 20px;
  }
}

.aside-left {
  position: fixed;
  z-index: 3;
  height: 100%;
  overflow-y: auto;

  .my-menu {
    height: 100%;
    border-right: none;

    .is-active {
      background-color: rgba(102, 102, 102) !important;

      &.menu-item:hover {
        background-color: rgba(102, 102, 102) !important;
      }
    }

    .logo {
      display: block;
      text-align: center;
      padding: 15px 0;
      border-bottom: solid 1px rgb(101, 101, 101);

      img {
        height: 28px;
      }
    }

    .menu-item {
      text-align: left;
      height: 50px;
      line-height: 50px;
      font-size: 14px;

      &:hover {
        background-color: rgb(63, 63, 63) !important;
      }
    }

    .el-icon- {
      margin-right: 10px !important;
    }
  }
}

/deep/ .bread {
  padding: 0;

  .crumb {
    padding: 16px 0;
    margin: 0 20px;
    border-bottom: solid 1px #e5e5e5;
  }
}

.console-header {
  height: 60px;
  line-height: 60px;
  /*background: rgba(41, 2, 2, 1);*/
  background: #ec1c1c;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  position: relative;
  z-index: 10;

  &.nbd {
    background: rgba(255, 255, 255, 0.1);
  }
  .moreInfo {
    display: flex;
    align-items: center;
  }

  ul {
    list-style: none;
    margin-right: 20px;
    width: 47vw;
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;
  }

  li {
    cursor: pointer;
    float: left;
    list-style: none;
    text-align: center;
    width: 9vw;
    height: 60px;

    a {
      display: block;
      color: rgba(255, 255, 255, 1);
      text-decoration: none;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.31);
    }

    &.active {
      background: rgba(255, 255, 255, 0.31);
    }
  }

  .account {
    z-index: 1;
    position: relative;
    &:hover {
      .comp-expand {
        transform: translateY(0);
      }
    }
    .comp-expand {
      position: absolute;
      width: calc(100% - 4px);
      z-index: 5;
      top: 56px;
      left: 2px;
      background-color: #ffffff;
      box-shadow: 0 2px 3px #ddd;
      transform: translateY(-100%);
      transition: all 0.3s;

      /deep/ .change-account {
        li {
          border-bottom: solid 1px #ddd;
          .current-user {
            right: 15px;
          }
        }

        .search-profile {
          position: absolute;
          background-color: #ffffff;
          padding: 0 20px;
          border-bottom: solid 1px #ddd;
        }

        .wrap {
          overflow-y: auto;
          max-height: 420px;
        }
      }
    }
    .nw {
      position: relative;
      z-index: 6;
    }

    .photo {
      width: 25px;
      height: 25px;
      margin-right: 5px;
      border-radius: 50%;
    }

    .name {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 12vw;
      // max-width: 220px;
      // min-width: 160px;
      margin-right: 3px;
      cursor: pointer;
    }

    .comp-expand {
      width: 0;
      height: 0;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
      position: absolute;
      z-index: -1;
      top: 56px;
      left: 2px;
      background-color: #ffffff;
      transform: translateY(-100%);
      /*transition: all .3s;*/
      opacity: 0;
      color: #000000;
      border-radius: 5px;
      overflow: hidden;
      /*width: 130%;*/
      transition-property: opacity, top, transform;
      transition-duration: 0.2s, 0.2s, 0.2s;
      transition-timing-function: ease;

      /deep/ .change-account {
        li {
          border-bottom: solid 1px #ddd;
          .current-user {
            right: 15px;
          }
        }

        .search-profile {
          position: absolute;
          background-color: #ffffff;
          padding: 0 20px;
          border-bottom: solid 1px #ddd;
        }

        .wrap {
          overflow-y: auto;
          max-height: 420px;
        }
      }
    }

    &:hover {
      .el-icon-arrow-right {
        transform: rotate(90deg);
      }

      .comp-expand {
        height: auto;
        min-width: 300px;
        /*z-index: 2;*/
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}

.flex-b {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    .el-icon-caret-bottom {
      transform: rotate(180deg);
    }
  }
}

.con-box {
  width: 1366px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

.ls-sh {
  height: 100%;
  display: inline-block;
  position: relative;

  img {
    display: inline-block;
    width: 25px;
    height: 25px;
    margin-right: 5px;
    border-radius: 50%;
  }

  .icon {
    cursor: pointer;
    margin-left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// layouts/entconsolelayout.vue